export default __webpack_public_path__ + "static/media/Image2022.86117990.png";